import * as rConst from "../actions/reviewConst";
import axios from "axios";

const state = {
  reviewApi: (process.env.VUE_APP_USTAGE_API || "http://localhost:3000/api") + "/Reviews",

  status: {}
};

for(let x in rConst) {
  state.status[x] = false
}

const getters = {
  isUpdatingReview: state => state.status[rConst.REVIEW_UPDATE],
  isSendingReview: state => state.status[rConst.REVIEW_ADD],
}

const actions = {
  [rConst.REVIEW_ADD]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      commit(rConst.REVIEW_ADD);
      axios
        .post(state.reviewApi + '/addReview', {review: data})
        .then(res => {
          commit(rConst.REVIEW_ADD_SUCCESS);
          resolve(res);
        })
        .catch(err => {
          commit(rConst.REVIEW_ADD_ERROR);
          reject(err);
        });
    })
  },
  [rConst.REVIEW_GET_AUTHOR]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(rConst.REVIEW_GET_AUTHOR);
      axios
        .get(state.reviewApi + '/getReviews')
        .then(res => {
          commit(rConst.REVIEW_GET_AUTHOR_SUCCESS);
          resolve(res.data);
        })
        .catch(err => {
          commit(rConst.REVIEW_GET_AUTHOR_ERROR);
          reject(err);
        });
    })
  },
  [rConst.REVIEW_GET_USER]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      commit(rConst.REVIEW_GET_USER);
      axios
        .get(state.reviewApi + '/getReviewForUser', {params: {id: data.id}})
        .then(res => {
          commit(rConst.REVIEW_GET_USER_SUCCESS);
          resolve(res.data);
        })
        .catch(err => {
          commit(rConst.REVIEW_GET_USER_ERROR);
          reject(err);
        });
    })
  },
  [rConst.REVIEW_UPDATE]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      commit(rConst.REVIEW_UPDATE);
      axios
        .put(state.reviewApi + '/updateReview', {review: data})
        .then(res => {
          commit(rConst.REVIEW_UPDATE_SUCCESS);
          resolve(res);
        })
        .catch(err => {
          commit(rConst.REVIEW_UPDATE_ERROR);
          reject(err);
        });
    })
  },
  [rConst.REVIEW_DELETE]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      commit(rConst.REVIEW_DELETE);
      axios
        .put(state.reviewApi + '/deleteReview', {id: data.id})
        .then(res => {
          commit(rConst.REVIEW_DELETE_SUCCESS);
          resolve(res);
        })
        .catch(err => {
          commit(rConst.REVIEW_DELETE_ERROR);
          reject(err);
        });
    })
  },
  [rConst.REVIEW_GET_LIST_ID]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(rConst.REVIEW_GET_LIST_ID);
      axios
        .get(state.reviewApi + '/getRatedUsers')
        .then(res => {
          commit(rConst.REVIEW_GET_LIST_ID_SUCCESS);
          resolve(res.data);
        })
        .catch(err => {
          commit(rConst.REVIEW_GET_LIST_ID_ERROR);
          reject(err);
        });
    })
  },

};

const mutations = {
  [rConst.REVIEW_ADD]: state => {
    state.status[rConst.REVIEW_ADD_SUCCESS] = false
    state.status[rConst.REVIEW_ADD_ERROR] = false
    state.status[rConst.REVIEW_ADD] = true
  },
  [rConst.REVIEW_ADD_SUCCESS]: state => {
    state.status[rConst.REVIEW_ADD] = false
    state.status[rConst.REVIEW_ADD_SUCCESS] = true
  },
  [rConst.REVIEW_ADD_ERROR]: state => {
    state.status[rConst.REVIEW_ADD] = false
    state.status[rConst.REVIEW_ADD_ERROR] = true
  },
  [rConst.REVIEW_GET_AUTHOR]: state => {
    state.status[rConst.REVIEW_GET_AUTHOR_SUCCESS] = false
    state.status[rConst.REVIEW_GET_AUTHOR_ERROR] = false
    state.status[rConst.REVIEW_GET_AUTHOR] = true
  },
  [rConst.REVIEW_GET_AUTHOR_SUCCESS]: state => {
    state.status[rConst.REVIEW_GET_AUTHOR] = false
    state.status[rConst.REVIEW_GET_AUTHOR_SUCCESS] = true
  },
  [rConst.REVIEW_GET_AUTHOR_ERROR]: state => {
    state.status[rConst.REVIEW_GET_AUTHOR] = false
    state.status[rConst.REVIEW_GET_AUTHOR_ERROR] = true
  },
  [rConst.REVIEW_GET_USER]: state => {
    state.status[rConst.REVIEW_GET_USER_SUCCESS] = false
    state.status[rConst.REVIEW_GET_USER_ERROR] = false
    state.status[rConst.REVIEW_GET_USER] = true
  },
  [rConst.REVIEW_GET_USER_SUCCESS]: state => {
    state.status[rConst.REVIEW_GET_USER] = false
    state.status[rConst.REVIEW_GET_USER_SUCCESS] = true
  },
  [rConst.REVIEW_GET_USER_ERROR]: state => {
    state.status[rConst.REVIEW_GET_USER] = false
    state.status[rConst.REVIEW_GET_USER_ERROR] = true
  },
  [rConst.REVIEW_UPDATE]: state => {
    state.status[rConst.REVIEW_UPDATE_SUCCESS] = false
    state.status[rConst.REVIEW_UPDATE_ERROR] = false
    state.status[rConst.REVIEW_UPDATE] = true
  },
  [rConst.REVIEW_UPDATE_SUCCESS]: state => {
    state.status[rConst.REVIEW_UPDATE] = false
    state.status[rConst.REVIEW_UPDATE_SUCCESS] = true
  },
  [rConst.REVIEW_UPDATE_ERROR]: state => {
    state.status[rConst.REVIEW_UPDATE] = false
    state.status[rConst.REVIEW_UPDATE_ERROR] = true
  },
  [rConst.REVIEW_DELETE]: state => {
    state.status[rConst.REVIEW_DELETE_SUCCESS] = false
    state.status[rConst.REVIEW_DELETE_ERROR] = false
    state.status[rConst.REVIEW_DELETE] = true
  },
  [rConst.REVIEW_DELETE_SUCCESS]: state => {
    state.status[rConst.REVIEW_DELETE] = false
    state.status[rConst.REVIEW_DELETE_SUCCESS] = true
  },
  [rConst.REVIEW_DELETE_ERROR]: state => {
    state.status[rConst.REVIEW_DELETE] = false
    state.status[rConst.REVIEW_DELETE_ERROR] = true
  },
  [rConst.REVIEW_GET_LIST_ID]: state => {
    state.status[rConst.REVIEW_GET_LIST_ID_SUCCESS] = false
    state.status[rConst.REVIEW_GET_LIST_ID_ERROR] = false
    state.status[rConst.REVIEW_GET_LIST_ID] = true
  },
  [rConst.REVIEW_GET_LIST_ID_SUCCESS]: state => {
    state.status[rConst.REVIEW_GET_LIST_ID] = false
    state.status[rConst.REVIEW_GET_LIST_ID_SUCCESS] = true
  },
  [rConst.REVIEW_GET_LIST_ID_ERROR]: state => {
    state.status[rConst.REVIEW_GET_LIST_ID] = false
    state.status[rConst.REVIEW_GET_LIST_ID_ERROR] = true
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
}